/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DailyTaskItemDto } from './DailyTaskItemDto';
import {
    DailyTaskItemDtoFromJSON,
    DailyTaskItemDtoFromJSONTyped,
    DailyTaskItemDtoToJSON,
    DailyTaskItemDtoToJSONTyped,
} from './DailyTaskItemDto';
import type { DailyTaskProgressDto } from './DailyTaskProgressDto';
import {
    DailyTaskProgressDtoFromJSON,
    DailyTaskProgressDtoFromJSONTyped,
    DailyTaskProgressDtoToJSON,
    DailyTaskProgressDtoToJSONTyped,
} from './DailyTaskProgressDto';

/**
 * 
 * @export
 * @interface DailyTaskGroupDto
 */
export interface DailyTaskGroupDto {
    /**
     * 
     * @type {string}
     * @memberof DailyTaskGroupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskGroupDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskGroupDto
     */
    category: DailyTaskGroupDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskGroupDto
     */
    categoryDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskGroupDto
     */
    interactionType: DailyTaskGroupDtoInteractionTypeEnum;
    /**
     * Total available points in this task group
     * @type {number}
     * @memberof DailyTaskGroupDto
     */
    points: number;
    /**
     * Points earned from completed items in this group
     * @type {number}
     * @memberof DailyTaskGroupDto
     */
    completedPoints: number;
    /**
     * 
     * @type {boolean}
     * @memberof DailyTaskGroupDto
     */
    isCompleted: boolean;
    /**
     * False when the corresponding medical instruction has been deleted
     * @type {boolean}
     * @memberof DailyTaskGroupDto
     */
    isAvailable: boolean;
    /**
     * 
     * @type {DailyTaskProgressDto}
     * @memberof DailyTaskGroupDto
     */
    progress?: DailyTaskProgressDto | null;
    /**
     * 
     * @type {Array<DailyTaskItemDto>}
     * @memberof DailyTaskGroupDto
     */
    items: Array<DailyTaskItemDto>;
}


/**
 * @export
 */
export const DailyTaskGroupDtoCategoryEnum = {
    Medication: 'medication',
    Nutrition: 'nutrition',
    Hydration: 'hydration',
    Exercise: 'exercise',
    Lifestyle: 'lifestyle'
} as const;
export type DailyTaskGroupDtoCategoryEnum = typeof DailyTaskGroupDtoCategoryEnum[keyof typeof DailyTaskGroupDtoCategoryEnum];

/**
 * @export
 */
export const DailyTaskGroupDtoInteractionTypeEnum = {
    Checklist: 'checklist',
    HydrationRecords: 'hydration_records'
} as const;
export type DailyTaskGroupDtoInteractionTypeEnum = typeof DailyTaskGroupDtoInteractionTypeEnum[keyof typeof DailyTaskGroupDtoInteractionTypeEnum];


/**
 * Check if a given object implements the DailyTaskGroupDto interface.
 */
export function instanceOfDailyTaskGroupDto(value: object): value is DailyTaskGroupDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('categoryDisplayName' in value) || value['categoryDisplayName'] === undefined) return false;
    if (!('interactionType' in value) || value['interactionType'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('completedPoints' in value) || value['completedPoints'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('isAvailable' in value) || value['isAvailable'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function DailyTaskGroupDtoFromJSON(json: any): DailyTaskGroupDto {
    return DailyTaskGroupDtoFromJSONTyped(json, false);
}

export function DailyTaskGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyTaskGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'category': json['category'],
        'categoryDisplayName': json['categoryDisplayName'],
        'interactionType': json['interactionType'],
        'points': json['points'],
        'completedPoints': json['completedPoints'],
        'isCompleted': json['isCompleted'],
        'isAvailable': json['isAvailable'],
        'progress': json['progress'] == null ? undefined : DailyTaskProgressDtoFromJSON(json['progress']),
        'items': ((json['items'] as Array<any>).map(DailyTaskItemDtoFromJSON)),
    };
}

export function DailyTaskGroupDtoToJSON(json: any): DailyTaskGroupDto {
    return DailyTaskGroupDtoToJSONTyped(json, false);
}

export function DailyTaskGroupDtoToJSONTyped(value?: DailyTaskGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'category': value['category'],
        'categoryDisplayName': value['categoryDisplayName'],
        'interactionType': value['interactionType'],
        'points': value['points'],
        'completedPoints': value['completedPoints'],
        'isCompleted': value['isCompleted'],
        'isAvailable': value['isAvailable'],
        'progress': DailyTaskProgressDtoToJSON(value['progress']),
        'items': ((value['items'] as Array<any>).map(DailyTaskItemDtoToJSON)),
    };
}

